"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  email: {
    "id": "users.email",
    "defaultMessage": "Email"
  },
  name: {
    "id": "users.name",
    "defaultMessage": "Name"
  },
  phone: {
    "id": "users.phone",
    "defaultMessage": "Phone"
  },
  roles: {
    "id": "users.roles",
    "defaultMessage": "Roles"
  },
  password: {
    "id": "users.password",
    "defaultMessage": "Password"
  },
  selectRoles: {
    "id": "users.selectRoles",
    "defaultMessage": "Select roles"
  },
  confirmPassword: {
    "id": "users.confirmPassword",
    "defaultMessage": "Confirm Password"
  },
  oldPassword: {
    "id": "users.oldPassword",
    "defaultMessage": "Old Password"
  },
  newPassword: {
    "id": "users.newPassword",
    "defaultMessage": "New Password"
  },
  confirmNewPassword: {
    "id": "users.confirmNewPassword",
    "defaultMessage": "Confirm New Password"
  },
  enterYourPhoneNumber: {
    "id": "users.enterYourPhoneNumber",
    "defaultMessage": "Enter your phone number"
  },
  enterYourName: {
    "id": "users.enterYourName",
    "defaultMessage": "Enter your name"
  },
  createAPassword: {
    "id": "users.createAPassword",
    "defaultMessage": "Create a password"
  },
  retypeYourPassword: {
    "id": "users.retypeYourPassword",
    "defaultMessage": "Retype your password"
  },
  emailDoesNotMatchThePattern: {
    "id": "users.emailDoesNotMatchThePattern",
    "defaultMessage": "Email does not match the pattern."
  },
  passwordComplexity: {
    "id": "users.passwordComplexityError",
    "defaultMessage": "Password requires at least one uppercase, at least one lowercase, at least one special character, at least one number and minimal length of {minLength} characters."
  },
  fieldsMustMatch: {
    "id": "users.fieldsMustMatch",
    "defaultMessage": "{field1} must be the same as {field2}."
  },
  addNewUser: {
    "id": "users.addNewUser",
    "defaultMessage": "Add new user"
  },
  updateUser: {
    "id": "users.updateUser",
    "defaultMessage": "Update User"
  },
  changePassword: {
    "id": "users.changePassword",
    "defaultMessage": "Change password"
  },
  switchTenant: {
    "id": "users.switchTenant",
    "defaultMessage": "Switch tenant"
  },
  searchTenants: {
    "id": "users.searchTenants",
    "defaultMessage": "Search tenants"
  },
  deleteUser: {
    "id": "users.deleteUser",
    "defaultMessage": "Delete User"
  },
  deleteDesc: {
    "id": "users.deleteDesc",
    "defaultMessage": "Are you sure you want to delete this user?"
  },
  deleteDesc2: {
    "id": "users.deleteDesc2",
    "defaultMessage": "This action cannot be undone."
  },
  resetPassword: {
    "id": "users.resetPassword",
    "defaultMessage": "Reset password"
  },
  resetDesc: {
    "id": "users.resetDesc",
    "defaultMessage": "Are you sure you want to reset password for"
  },
  resetDesc2: {
    "id": "users.resetDesc2",
    "defaultMessage": "An instructional email will be sent to the email address."
  },
  userSuccessfullyCreated: {
    "id": "users.userSuccessfullyCreated",
    "defaultMessage": "User was successfully created."
  },
  userSuccessfullyUpdated: {
    "id": "users.userSuccessfullyUpdated",
    "defaultMessage": "User was successfully updated."
  },
  userPasswordSuccessfullyChanged: {
    "id": "users.userPasswordSuccessfullyChanged",
    "defaultMessage": "User's password was successfully changed."
  },
  userSuccessfullyDeleted: {
    "id": "users.userSuccessfullyDeleted",
    "defaultMessage": "User was successfully deleted."
  },
  userPasswordSuccessfullyReset: {
    "id": "users.userPasswordSuccessfullyReset",
    "defaultMessage": "Password was successfully reset."
  },
  errorDuringUsersFetch: {
    "id": "users.errorDuringUsersFetch",
    "defaultMessage": "An error occurred while fetching the users."
  },
  errorDuringUserCreation: {
    "id": "users.errorDuringUserCreation",
    "defaultMessage": "An error occurred while creating a new user."
  },
  userAlreadyExists: {
    "id": "users.userAlreadyExists",
    "defaultMessage": "User with this email already exists."
  },
  errorDuringUserUpdate: {
    "id": "users.errorDuringUserUpdate",
    "defaultMessage": "An error occurred while updating a user."
  },
  errorDuringUserPasswordChange: {
    "id": "users.errorDuringUserPasswordChange",
    "defaultMessage": "An error occurred while changing a user's password."
  },
  errorPasswordNotChanged: {
    "id": "users.errorPasswordNotChanged",
    "defaultMessage": "User's password not changed."
  },
  errorDuringUserDeletion: {
    "id": "users.errorDuringUserDeletion",
    "defaultMessage": "An error occurred while deleting a user."
  },
  errorDuringPasswordReset: {
    "id": "users.errorDuringPasswordReset",
    "defaultMessage": "An error occurred while resetting a users password."
  },
  selectAUserToUpdateIt: {
    "id": "users.selectAUserToUpdateIt",
    "defaultMessage": "Select a user profile to see or edit its details."
  },
  viewProfile: {
    "id": "users.viewProfile",
    "defaultMessage": "View profile"
  },
  logout: {
    "id": "users.logout",
    "defaultMessage": "Logout"
  },
  atLeastOneRoleIsRequired: {
    "id": "users.atLeastOneRoleIsRequired",
    "defaultMessage": "At least one Role has to be assigned to a User."
  },
  authenticationProviders: {
    "id": "users.authenticationProviders",
    "defaultMessage": "Authentication Providers"
  }
});
exports.messages = messages;
//# sourceMappingURL=users-i18n.js.map